import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/navsamarbeid.jpeg";

function NavCollaboration() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.navCollaboration.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.navCollaboration.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/nav-samarbeid"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.navCollaboration.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.navCollaboration.description")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.navCollaboration.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5">
        <img
          src={article_img}
          alt={i18next.t("pages.articles.list.navCollaboration.imageAlt")}
        />
        <p className="text-sm text-secondary text-left mt-2">{i18next.t("pages.articles.list.navCollaboration.imageCaption")}</p>
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.navCollaboration.sections.history.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.navCollaboration.sections.history.content")}
              <a href="/om-xper" className=" underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.navCollaboration.sections.history.link")}
              </a>
              {i18next.t("pages.articles.list.navCollaboration.sections.history.content2")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.navCollaboration.sections.team.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.navCollaboration.sections.team.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.navCollaboration.sections.collaboration.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.navCollaboration.sections.collaboration.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.navCollaboration.sections.flexibility.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.navCollaboration.sections.flexibility.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.navCollaboration.sections.recommendation.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.navCollaboration.sections.recommendation.content")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NavCollaboration; 